import * as TextVariables from "../../assets/Variables/TextVariables.js";
import Colors from "../../assets/Variables/ColorsVariables.js";
import { Spaces } from "../../assets/Variables/SpaceVariables.js";

export const mainPaper = {
  display: "flex",
  flexDirection: "column",
  width: "calc(100vw - 280px)",
  maxWidth: "1110px",
  borderRadius: "12px",
  padding: Spaces.Size_5,
  gap: Spaces.Size_8,
};

export const linkButton = {
  width: "118px",
  fontFamily: TextVariables.Caption_2,
  color: Colors.Secondary_800,
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  padding: `${Spaces.Size_1} ${Spaces.Size_2}`,
  gap: "2px",
  borderRadius: Spaces.Size_2,
};

export const accountPreferences = {
  width: "calc(100vw - 280px)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: Spaces.Size_5,
  maxWidth: "1110px",
}

export const paperPassword = {
  display: "flex",
  flexDirection: "column",
  padding: Spaces.Size_5,
  width: "calc(100vw - 280px)",
  maxWidth: "440px",
  borderRadius: "12px",
}

export const changePasswordButtonContainer = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "right",
  marginTop: "15px"
};

